module.exports = __webpack_public_path__ + "img/figure-9.ac8b161f.png";